var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification"},[_c('div',{ref:"notification",staticClass:"new-notification"},[_c('h1',[_vm._v(_vm._s(_vm.notification))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }